import React, { createContext, useContext, useRef, useState } from "react";
import Toast from "../Component/Toast";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const timerRef = useRef(null);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "error",
  });

  const showToast = (message, type = "error") => {
    if (timerRef.current) clearTimeout(timerRef.current);

    setToast({ show: true, message, type });

    timerRef.current = setTimeout(() => {
      setToast({ show: false, message: "", type });
    }, 3000);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast.show && (
        <Toast message={toast.message} type={toast.type} />
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
